import {permission} from './permissions';

export const roles = {
    ADMINISTRATOR: 'ADMINISTRATOR',
    ORGANIZATION_ADMINISTRATOR: 'ORGANIZATION_ADMINISTRATOR',
    ORGANIZATION_CLINIC_ADMINISTRATOR: 'ORGANIZATION_CLINIC_ADMINISTRATOR',
    QUALITY_CONTROL: 'QUALITY_CONTROL',
    CLINIC_ADMINISTRATOR: 'CLINIC_ADMINISTRATOR',
    CLINIC_LAB: 'CLINIC_LAB',
    CLINIC_USER: 'CLINIC_USER',
    CLINIC_USER_FULL_INSIGHT: 'CLINIC_USER_FULL_INSIGHT',
    API_USER: 'API_USER',
    C4T_USER: 'C4T_USER',
    INTEGRATION_USER: 'INTEGRATION_USER'
};

export const roleWeights = {
    [roles.ADMINISTRATOR]: 100,
    [roles.ORGANIZATION_ADMINISTRATOR]: 90,
    [roles.QUALITY_CONTROL]: 80,
    [roles.ORGANIZATION_CLINIC_ADMINISTRATOR]: 75,
    [roles.CLINIC_ADMINISTRATOR]: 70,
    [roles.CLINIC_LAB]: 60,
    [roles.CLINIC_USER_FULL_INSIGHT]: 50,
    [roles.CLINIC_USER]: 40,
    [roles.API_USER]: 30,
    [roles.C4T_USER]: 20,
    [roles.INTEGRATION_USER]: 10
};

const roleAssignmentPermissions = {
    [roles.ADMINISTRATOR]: [permission.role_setAdministrator],
    [roles.ORGANIZATION_ADMINISTRATOR]: [permission.role_setOrganizationAdministrator],
    [roles.ORGANIZATION_CLINIC_ADMINISTRATOR]: [permission.role_setOrganizationClinicAdministrator],
    [roles.QUALITY_CONTROL]: [permission.role_setQualityControl],
    [roles.CLINIC_ADMINISTRATOR]: [permission.role_setClinicAdministrator, permission.role_setClinicAdministrator_clinic],
    [roles.CLINIC_LAB]: [permission.role_setClinicLab],
    [roles.CLINIC_USER]: [permission.role_setClinicUser],
    [roles.CLINIC_USER_FULL_INSIGHT]: [permission.role_setClinicUserFullInsight],
    [roles.API_USER]: [permission.role_setApiUser],
    [roles.C4T_USER]: [permission.role_setC4TUser],
    [roles.INTEGRATION_USER]: [permission.role_setIntegrationUser]
};

// Clinic-scoped assignments are validated against the target clinic by the API.
export const canAssignRole = (role, userPermissions = []) =>
    (roleAssignmentPermissions[role] || []).some(value => userPermissions.includes(value));

export const hasRequiredRole = (userRoles, requiredRole) => {
    if (!userRoles || !requiredRole) return false;
    const requiredRoleWeight = roleWeights[requiredRole];
    return userRoles.every(role => roleWeights[role] <= requiredRoleWeight);
};
